import { createListenerMiddleware } from '@reduxjs/toolkit';
import { loadSession, logout } from '@appblocks/frontend/redux/userSlice';
import Session from 'supertokens-auth-react/recipe/session';
import posthog from 'posthog-js';
import { inIframe } from '@appblocks/frontend/client/utils';


const axios = require('axios');

const userMiddleware = createListenerMiddleware();
userMiddleware.startListening({
    actionCreator: loadSession,
    effect: async (action, store) => {
        try {
            if (inIframe()) {
                store.dispatch({
                    type: 'user/setLoaded',
                    payload: true,
                });
                return;
            }
            const user = await new Promise((resolve, reject) => {
                axios.get(`${process.env.API_URL}/api/account/session`, {
                    withCredentials: true,
                })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((e) => {
                        reject();
                    });
            });
            store.dispatch({
                type: 'user/setUser',
                payload: user,
            });
            let cloudEnabled = process.env.CLOUD_FEATURE_FLAG === '1';
            let micropythonEnabled = process.env.MICROPYTHON_FEATURE_FLAG === '1';
            let zephyrEnabled = process.env.ZEPHYR_FEATURE_FLAG === '1';
            let customFeatureEnabled = process.env.CUSTOM_FEATURE_FLAG === '1';
            if (user && user.id) {
                posthog.identify(
                    user.id, // Replace 'distinct_id' with your user's unique identifier
                    { email: user.email }, // optional: set additional user properties
                );
                if (posthog.isFeatureEnabled('cloud')) {
                    cloudEnabled = true;
                }
                if (posthog.isFeatureEnabled('micropython')) {
                    micropythonEnabled = true;
                }
                if (posthog.isFeatureEnabled('zephyr')) {
                    zephyrEnabled = true;
                }
                if (posthog.isFeatureEnabled('customFeature')) {
                    customFeatureEnabled = true;
                }
            }
            store.dispatch({
                type: 'user/setFeatureFlag',
                payload: {
                    name: 'cloud',
                    value: cloudEnabled,
                },
            });
            store.dispatch({
                type: 'user/setFeatureFlag',
                payload: {
                    name: 'micropython',
                    value: micropythonEnabled,
                },
            });
            store.dispatch({
                type: 'user/setFeatureFlag',
                payload: {
                    name: 'zephyr',
                    value: zephyrEnabled,
                },
            });
            store.dispatch({
                type: 'user/setFeatureFlag',
                payload: {
                    name: 'customFeature',
                    value: customFeatureEnabled,
                },
            });
        } catch (e) {
            // console.error(e);
        } finally {
            store.dispatch({
                type: 'user/setLoaded',
                payload: true,
            });
        }
    },
});

userMiddleware.startListening({
    actionCreator: logout,
    effect: async (action, store) => {
        try {
            await Session.signOut();
            window.location.href = '/';
            store.dispatch({
                type: 'user/setUser',
                payload: undefined,
            });
        } catch (e) {
            window.location.href = '/';
            store.dispatch({
                type: 'user/setUser',
                payload: undefined,
            });
        }
    },
});

export default userMiddleware;
